<app-card
  [title]="'admin.solution.solution_information'|translate"
  [cardOptionBtn]="true"
  cardOptionBtnValue="{{'admin.solution.edit.title'|translate}}"
  [cardRouterLink]="'/back-office/service/solution/' + solution.id + '/edit'"
>
  <div class="row">
    <div class="col-sm-12 col-xl-3">
      <p class="text-muted m-b-10">{{'doctrine.solution.name'|translate}}</p>
      <label class="m-b-15">{{solution.name}}</label>
    </div>
    <div class="col-sm-12 col-xl-3">
      <p class="text-muted m-b-10">{{'global.status'|translate}}</p>
      <label class="m-b-15">{{(solution.status ? 'global.active' : 'global.inactive')|translate}}</label>
    </div>
    <div class="col-sm-12 col-xl-6">
      <p class="text-muted m-b-10">{{'doctrine.solution.subjects'|translate}}</p>
      <label class="m-b-10">
        <ng-container *ngIf="solution.serviceSubjects?.length;else noStyle">
            <span
              *ngFor="let subject of solution.serviceSubjects;let last=last;let index=index;">{{subject.name}}{{last ? '' : ',' }}
            </span>
        </ng-container>
        <ng-template #noStyle>{{'admin.solution.no_subject'|translate}}</ng-template>
      </label>
    </div>
  </div>
</app-card>
<app-solution-template></app-solution-template>
